import { Point } from '@/types';
import { getClosestPointOnAngleLine } from './getClosestPointOnLine';
import { getVectorLength } from './getVectorLength';
import { isHorizontalLine, isVerticalLine } from './isLineType';
import { subtractVectors } from './subtractVectors';
import { Line } from './types';

export const getDistanceFromPointToLine = (line: Line, point: Point): [number, Point] => {
  if (isHorizontalLine(line)) {
    const difference = line.y - point.y;
    return [Math.abs(difference), { x: 0, y: difference }];
  }

  if (isVerticalLine(line)) {
    const difference = line.x - point.x;
    return [Math.abs(difference), { x: difference, y: 0 }];
  }

  const closestPointOnLine = getClosestPointOnAngleLine(line, point);
  const snapDifference = subtractVectors(closestPointOnLine, point);
  return [getVectorLength(snapDifference), snapDifference];
};
